  
    import React from 'react';

    const LoadingSpinner = () => (
      <div className="text-center">
        <i className="fa fa-spinner fa-spin" /> Your content is being loaded...
      </div>
    );

    export default LoadingSpinner;
  
